<template>
  <div class="summary-view">
    <p>
      <span>{{ $t("common.city") }}:</span>
      <q-chip
        v-if="selectedCity"
        color="primary"
        text-color="white"
        icon="local_grocery_store"
      >
        {{ selectedCity.label }}
      </q-chip>
    </p>
    <p>
      <span>{{ $t("common.country") }}:</span>
      <q-chip
        v-if="selectedCountry"
        color="primary"
        text-color="white"
        icon="my_location"
      >
        {{ selectedCountry.label }}
      </q-chip>
    </p>
    <p>
      <span>{{ $t("common.event") }}:</span>
      <q-chip
        v-if="selectedEvent"
        color="primary"
        text-color="white"
        icon="camera_front"
      >
        {{ selectedEvent.label }}
      </q-chip>
    </p>
    <p>
      <span>{{mediaTypeLabel}}</span>
      <q-chip
        v-if="mediaCount > 0"
        color="primary"
        text-color="white"
        icon="camera_front"
      >
        x{{ mediaCount }}
      </q-chip>
    </p>
  </div>
</template>

<script>
export default {
  name: "StepperSummary",
  props: {
    selectedCity: {
      type: [Object, String],
      default: () => null,
    },
    selectedCountry: {
      type: [Object, String],
      default: () => null,
    },
    selectedEvent: {
      type: [Object, String],
      default: () => null,
    },
    mediaCount: {
      type: Number,
      default: 0,
    },
    mediaTypeLabel: {
      type: String,
      required: true
    },
  },
};
</script>

<style scoped>
</style>